import React from "react";
import AAutoComplete from "../../views/pages/manage/common/form-fields-mui/AAutoComplete";
import CustomDatePickerV2 from "../../views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import AButton from "../../views/pages/manage/common/form-fields-mui/AButton";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";

const defaultContainerStyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: "324px",
  padding: "1rem",
};

export const getInputField = (formField, handleFilterForm, filterForm) => {
  const {
    label,
    type,
    formKey,
    onChange = () => {},
    placeholder,
    disabled,
  } = formField;
  switch (type) {
    case "select": {
      const { items, loading, isMulti, isShowCount } = formField;
      return (
        <AAutoComplete
          key={formKey}
          label={label}
          items={items}
          style={{ control: { height: "40px", borderRadius: "4px" } }}
          currentValue={filterForm[formKey]}
          handleChange={(val) => {
            handleFilterForm(formKey, val);
            onChange(val);
          }}
          isMulti={isMulti}
          isLoading={loading}
          placeholder={placeholder}
          isDisabled={disabled}
          isShowCount={isShowCount}
        />
      );
    }
    case "date": {
      const { minDate, maxDate } = formField;
      return (
        <CustomDatePickerV2
          key={formKey}
          label={label}
          value={filterForm[formKey]}
          handler={(index, date) => {
            handleFilterForm(formKey, date);
            onChange(date);
          }}
          placeHolder={placeholder}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
        />
      );
    }
    case "text": {
      const { minDate, maxDate } = formField;
      return (
        <AInput
          label={label}
          value={filterForm[formKey]}
          placeHolder ="Enter"
          handler={(value) => handleFilterForm(formKey, value)}
          style={{ height: "40px", borderRadius: "4px" }}
        />
      );
    }
    default:
      return null;
  }
};

const FormFields = ({
  formFields,
  filterForm = {},
  applyFilterHandler = () => {},
  removeFilterHandler = () => {},
  containerStyles = {},
  handleFilterForm,
  closePopup,
  twoColumnLayout = false,
}) => {
  console.log(formFields, "formFields");
  return (
    <div
      style={{ ...defaultContainerStyles, ...containerStyles }}
      className="a-card m-0"
    >
      <div className="large-bold color-black">Filters</div>

      {twoColumnLayout ? (
        <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
          {formFields?.map((formField) => {
            const width = "48%"; // 2 per row only when colSpan=1
            return (
              <div key={formField.formKey} style={{ width }}>
                {getInputField(formField, handleFilterForm, filterForm)}
              </div>
            );
          })}
        </div>
      ) : (
        <>
          {formFields?.map((formField) => (
            <div key={formField.formKey}>
              {getInputField(formField, handleFilterForm, filterForm)}
            </div>
          ))}
        </>
      )}

      <div className="d-flex justify-content-between mt-2">
        <AButton
          variant="danger_filled"
          onClick={async () => {
            await removeFilterHandler();
            closePopup();
          }}
          size="xs"
          className="no-ml-btn"
        >
          Remove
        </AButton>

        <AButton
          variant="primary_filled"
          onClick={async () => {
            await applyFilterHandler(filterForm);
            closePopup();
          }}
          size="xs"
        >
          Apply
        </AButton>
      </div>
    </div>
  );
};

export default FormFields;
